//const MODE = "staging"
//const MODE = "ssk"
const MODE = "wsf" // develop
//const MODE = "cc1"
//const MODE = "cc2"
//const MODE = "cc3"
//const MODE = "production"
// const MODE = "local"

// pscp -r .\dist\ armin@service.psyfiers.ch:/opt/staging/admincc
// pscp -r .\dist\ an@prod.swiss-skills.ch:/opt/node/admincc
// pscp -r .\dist\ armin@service.psyfiers.ch:/opt/node/admincc

module.exports = {
    defaults: {
        mode: MODE,
        i18n: MODE === "ssk" ? "i18n-ssk.json" : MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? "i18n-wsf.json" : "i18n-default.json",
        country: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? "FR" : "CH",
        language: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? "fr" : "de",
        defaultCurrency: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? "EUR" : null,
        extendProjectList: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? false : true,
        disableFacturing: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        hideUserLanguage: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        defaultUserLanguage: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? "fr" : "de",
        hideUserMobile: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        hideLanguageSelector: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        hideVatNumber: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        hideTaxnumber: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        hidePostbox: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        hideCountryAddress: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        hideDeliveryAddress: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        hideAccountPhonenumber: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? true : false,
        vipDefaultLanguage: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? "fr" : null,
        downloadLanguage: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? "fr" : null,
        externalURL: MODE === "wsf" || MODE === "cc2" || MODE === "cc3" ? "https://mission-future.com" : null
    },
    server: {
        protocol: "https",
        host: MODE === "staging" ? "staging.psyfiers.ch" : MODE === "ssk" ? "prod.swiss-skills.ch" : MODE === "wsf" ? "develop.psyfiers.ch" : MODE === "cc1" ? "cc1.psyfiers.ch" : MODE === "cc2" ? "cc2.psyfiers.ch" : MODE === "cc3" ? "cc3.psyfiers.ch" : "service.psyfiers.ch",
        basePath: "/core"
    },
    location: {
        street: "Sumpfstrasse 5",
        country: {
            id: "CH"
        },
        postcode: 6312,
        city: "Steinhausen"
    },
    home: MODE === "wsf" ? [
        "FR"
    ] : [
        "CH",
        "LI"
    ],
    euCountries: [
        "AD",
        "PT",
        "BE",
        "DK",
        "DE",
        "GB",
        "FI",
        "FR",
        "NL",
        "IE",
        "IT",
        "GG",
        "JE",
        "LU",
        "PT",
        "MC",
        "NO",
        "AT",
        "PT",
        "SM",
        "SE",
        "ES"
    ]
}